<template>
  <v-navigation-drawer
    dark
    app
    :clipped="clipped"
    :fixed="fixed"
    :permanent="permanent"
    :mini-variant="mini"
    :temporary=true
    v-model="showDrawer"
    width="200"
    height="150"
  >

    <v-list
      expand
      dense
    >
      <v-list-tile>
        <v-list-tile-content>
          <v-btn
            flat
            color="white"
            to="/conseils"
          >
            Conseils CV
          </v-btn>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile>
        <v-list-tile-content>
          <v-btn
            outline
            round
            color="white"
            to="/login"
          >
            connection
          </v-btn>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile>
        <v-list-tile-content>
          <v-btn
            round
            color="success"
            to='/register'
          >
            Inscription
          </v-btn>
        </v-list-tile-content>
      </v-list-tile>

    </v-list>

  </v-navigation-drawer>
</template>

<script>

 /*
    Utilisation de <v-container> dans les v-list-tile des boutons.
    Sinon problème de centrage.
  */

 import { mapActions, mapState } from 'vuex';


 export default {
   components: {
   },
   data() {
     return {
       drawer: {
         mobileBreakPoint: 960,
         width: 320,
       },
       itemHome: {
         action: 'home',
         title: 'Mes Curriculum Vitae',
       },
       itemsSection: {
         action: 'edit',
         title: 'Edition du CV',
         active: true,

         items: [
           { title: 'Infos Perso', icon:'face', link: "personal-infos" },
           { title: 'Profil', icon:'explore', link: "summary" },
           { title: 'Experiences PRO', icon:'business_center', link: "work-list" },
           { title: 'Formations', icon:'school', link: "edu-list" },
           { title: 'Compétences', icon:'build', link: "skill-list" },
           { title: 'Langues', icon:'language', link: "lang-list" },
           { title: 'Loisirs', icon:'wb_sunny', link: "hobby-list" },

         ]
       },
       controls: {
         action: 'apps',
         title: 'Controles',
         active: true,
       },
     }
   },
   computed: {
     /*
        NOTE sur l'ouverture/fermeture de la sidebar en mode mobile (overlay) avec vuex.
        https://stackoverflow.com/questions/47442621/managing-state-for-overlay-dismissed-components-in-vuetify
        voir computed property showDrawer ci-dessous.
        Il faut un getter ET un Ajouter un setter afin de récupérer l'événement binder sur v-model.
      */
     showDrawer: {
       get() {
         console.log('SidebarLanding open : ' + this.$store.state.sidebarLanding.open);
         return this.$store.state.sidebarLanding.open },
       set(val) { this.$store.commit('sidebarLanding/CLOSE_DRAWER', val) }
     },
     ...mapState('sidebarLanding', [
       'open',
       'clipped',
       'fixed',
       'permanent',
       'mini',
     ]),
   },
   methods : {
     ...mapActions('sidebarLanding', [
       'toggleDrawer',
       'closeDrawer',
     ]),
   }
 }
</script>
